import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';
import { msInboxApiUrl, buildMsInboxAuthHeaders } from '../../services/inbox/msInboxClient';
import fetchWithTimeout from '../../util/fetchWithTimeout';

const resource = `${MERCATELY_API}/campaigns`;

const model = abstractModel(resource);

model.getCampaigns = async (params) => model.get(params, { path: resource });
model.getCampaignDetail = async (id) => model.get({}, { path: `${resource}/${id}` });

model.getCampaignMessages = async (params, routeParams = {}) => {
  const campaignId = routeParams.id || routeParams.slug;
  const platformRetailerId = params?.platformRetailerId || routeParams.platformRetailerId;
  const numericCampaignId = params?.campaignId;

  if (platformRetailerId && numericCampaignId) {
    const queryParams = new URLSearchParams({
      campaign_id: numericCampaignId,
      page: params?.page || 1,
      per_page: params?.per_page || 25
    });
    const url = msInboxApiUrl(`/messages?${queryParams}`);
    const headers = await buildMsInboxAuthHeaders();
    const response = await fetchWithTimeout(url, { headers, mode: 'cors' });
    return response.json();
  }

  return model.get(params, { path: `${resource}/${campaignId}/messages` });
};

model.getCampaignStatsFromMs = async (numericCampaignId) => {
  const url = msInboxApiUrl(`/campaigns/${numericCampaignId}/stats`);
  const headers = await buildMsInboxAuthHeaders();
  const response = await fetchWithTimeout(url, { headers, mode: 'cors' });
  return response.json();
};

model.cancelCampaign = async (web_id) => model.cancel(web_id);
model.verifyBm = async () => model.post({}, { path: `${resource}/verify_bm` });
model.completeVideo = async (id) => model.post({}, { path: `${resource}/videos/${id}/complete` });

export default model;
